<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'FinancialChangesYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Has your overall wealth significantly increased or decreased, potentially affecting your inheritance tax situation?',
        subTitle: 'A major change in your net worth can drastically alter how much inheritance tax your estate will owe. If you have come into a large sum of money, your estate might now cross the tax threshold, requiring new planning strategies to protect your wealth. Conversely, if your wealth has decreased, complex tax planning provisions in your current Will might unnecessarily delay the administration of your estate.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'financialChangesYN',
        formPath: 'financialChangesYN',
        jsonSaveField: 'financialChangesYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
